<template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <base-nested-spinner
          :status="$data.$_nestedSpinnerMixin_status"
          @reload="fetchData">
          <base-card
            title="Rank of gene expression in each sample"
            icon="table_chart"
          >
            <v-flex xs12>
              <BaseDataTables
                :options="options"
                class="table-bordered table-striped"
              >
                <thead>
                <tr>
                  <th>Analysis ID</th>
                  <th>Study</th>
                  <th>Sample</th>
                  <th>Cancer Type</th>
                  <th>Tissue</th>
                  <th>Gene</th>
                  <th>Expression</th>
                  <th>Rank</th>
                </tr>
                </thead>
                <tbody>
                <tr
                  v-for="entity in data"
                  :key="entity.id"
                >
                  <td>{{entity.analysisId}}</td>
                  <td>{{entity.study}}</td>
                  <td>{{entity.gsm}}</td>
                  <td>{{entity.cancerType}}</td>
                  <td>{{entity.tissue}}</td>
                  <td>{{entity.gene}}</td>
                  <td>{{entity.expressionLevel}}</td>
                  <td>{{entity.expressionRank}}</td>
                </tr>
                </tbody>
              </BaseDataTables>
            </v-flex>
          </base-card>
        </base-nested-spinner>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { getSampleRanks } from '@/api/sampleRanks';
import nestedSpinnerMixin from '@/mixins/nestedSpinner';

export default {
  mixins: [nestedSpinnerMixin],
  props: {
    rna: {
      type: String,
      required: true,
    },
    analysisId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      data: [],
      options: {
        searching: false,
        dom: "<'row'<'col-sm-6'l><'col-sm-6 text-right'B>>" +
          "<'row'<'col-sm-12'tr>>" +
          "<'row'<'col-sm-5'i><'col-sm-7'p>>",
        buttons: [
          {
            extend: 'excelHtml5',
            title: 'Sample Ranks Data',
          },
          {
            extend: 'csvHtml5',
            title: 'Sample Ranks Data',
          },
        ],
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      const apiFn = () => getSampleRanks(this.rna, this.analysisId);
      const resolve = (data) => {
        this.data = data;
      };
      this.$_nestedSpinnerMixin_fetchData(apiFn, resolve);
    },
  },
};
</script>

<style scoped>

</style>
